export default "__VITE_ASSET__7e2921f0__"